import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import backArrowPage from "../../assets/icons/backArrowPage.svg";
import IsobTab1 from "./IsobTab1";
import IsobTab2 from "./IsobTab2";
import IsobTab3 from "./IsobTab3";
import IsobTab4 from "./IsobTab4";
import IsobTab5 from "./IsobTab5";
import { getMasterData } from "../../services/enquiryMaster-service";
import { getAllIsobData, getIsobData, getIsobBpData, getIsobPgCompData, getIsobDwgData, getIsobPgCommercialData, getIsobDealerSacData, getIsobAdvanceData, getIsobLdData, getIsobMiscData, getSalesManagerRole } from "../../services/isob-service";
import Alert from "../common/Alert";
import Loader from "../../assets/loader.gif";
import { getSalesUser } from "../../services/discount-services";
import { convertDateTimetoDateFormat } from "../../helpers/date-formatter";
import useIsobChangeTracker from "../../hooks/useIsobChangeTracker";

const tabLabels = ["Business Partner details", "Technical details", "Commercial details", "Project details", "Project timelines"];

export default function AddIsob({ orderBookingFormData = {}, initialFormValues = {}, onBack, enquiryData, action = "Add", discountRecord = {} }) {
    const [activeTab, setActiveTab] = useState(0);
    const today = new Date().toISOString().split("T")[0];

    const getSessionBpDefaults = () => {
        if (action !== "Add") return {};
        try {
            const raw = sessionStorage.getItem("UserData");
            if (!raw) return {};
            const parsed = JSON.parse(raw);
            const userData = parsed?.UserData || parsed;
            return {
                BPCode: userData?.Title || "",
                BPName: userData?.field_2 || "",
            };
        } catch {
            return {};
        }
    };

    const sessionDefaults = getSessionBpDefaults();

    const [formValues, setFormValues] = useState({
        POLOIDate: today,
        DAPTechApprovalDate: today,
        DealerSAC_applicable: "No",
        LD_applicable: "No",
        Advance: "0",
        againstDeliveryPercent: "100",
        againstInstallationPercent: "0",
        ...initialFormValues,
        ...Object.fromEntries(
        Object.entries(sessionDefaults).filter(([k]) => !initialFormValues[k])
    ),
    });
    console.log("actionInISOB", action);
    
    const [error, setError] = useState({});
    const [mandatoryFields, setMandatoryFields] = useState([]);
    const [resetKey, setResetKey] = useState(0);
    const [masterData, setMasterData] = useState([]);
    const [isobDropdownData, setIsobDropdownData] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [maxVisitedTab, setMaxVisitedTab] = useState(0);
    const [salesRole,setSalesRole] = useState([]);
    const [loading, setLoading] = useState(false);
    const [salesuser, setSalesuser] = useState([])
    const [fetchTrigger, setFetchTrigger] = useState(0);

    const changeTracker = useIsobChangeTracker();
    const isobRecordIds = useRef({});
    const [tabDirty, setTabDirty] = useState(false);
    const [pendingTab, setPendingTab] = useState(null);
    // const fetchedTabs = useRef(new Set());
    const fetchedTabs = useRef(
    action === "Edit" && Object.keys(initialFormValues).length > 0
        ? new Set([0, 1, 2, 3, 4])
        : new Set()
);
    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const masterValues = await getMasterData();
                console.log("masterValues", masterValues)
                setMasterData(masterValues.data.map((item) => ({ title: item.Title, value: item.Value })));
            } catch (err) {
                console.error("Error fetching master data", err);
            }
        };
        fetchMasterData();
    }, []);

    useEffect(() => {
        const fetchIsobDropdownData = async () => {
            try {
                const isobValues = await getAllIsobData();
                console.log("isobValues", isobValues)
                setIsobDropdownData(isobValues.data);
            } catch (err) {
                console.error("Error fetching ISOB dropdown data", err);
            }
        };
        fetchIsobDropdownData();
    }, []);

    useEffect(() => {
        if ((action !== "View" && action !== "Edit") || !orderBookingFormData?.ID) return;
        if (fetchedTabs.current.has(activeTab)) return;
        const obId = String(orderBookingFormData.ID);
        const isobObj = { obId };

        const fetchTabData = async () => {
            setLoading(true);
            try {
                if (activeTab === 0) {
                    const [isobRes, bpRes] = await Promise.all([
                        getIsobData(isobObj).catch(() => ({ data: [] })),
                        getIsobBpData(isobObj).catch(() => ({ data: [] })),
                    ]);
                    const isob = isobRes.data?.[0] || {};
                    const soldTo = (bpRes.data || []).find(bp => bp.BPType === "Sold To") || {};
                    const shipTo = (bpRes.data || []).find(bp => bp.BPType === "Ship To") || {};
                    isobRecordIds.current.isobId = isob.ID;
                    isobRecordIds.current.soldToId = soldTo.ID;
                    isobRecordIds.current.shipToId = shipTo.ID;
                    const bpFields = ["BPGSTN", "CIN", "TAN", "Location", "Pincode", "BPAddress", "ContactName", "ContactMobile", "ContactEmail", "ContactDesignation", "AddressCode"];
                    const copySoldTo = bpFields.some(f => soldTo[f] || shipTo[f]) && bpFields.every(f => (soldTo[f] != null ? String(soldTo[f]) : "") === (shipTo[f] != null ? String(shipTo[f]) : ""));
                    setFormValues(prev => ({
                        ...prev,
                        copySoldTo,
                        PO_number: isob.POnumber || "",
                        POLOIDate: convertDateTimetoDateFormat(isob.PODate) || today,
                        DAPTechApprovalDate: convertDateTimetoDateFormat(isob.TechApprovalDate) || today,
                        BOM_type: isob.BOM_type || "",
                        WHType: isob.Application || "",
                        SKU_stored: isob.SKU_stored || "",
                        DocumentExchangePlace: isob.DocumentExchangePlace || "",
                        RelatedToPastSupply: isob.Past_supply || "",
                        PastSONo: isob.SO_number || "",
                        BPCode: soldTo.BPCode || "",
                        BPName: soldTo.BPName || "",
                        BPGSTN: soldTo.BPGSTN || "",
                        CIN: soldTo.CIN || "",
                        BPTAN: soldTo.TAN || "",
                        Location: soldTo.Location || "",
                        Pincode: soldTo.Pincode != null ? String(soldTo.Pincode) : "",
                        BPAddress: soldTo.BPAddress || "",
                        ContactName: soldTo.ContactName || "",
                        Mobile: soldTo.ContactMobile != null ? String(soldTo.ContactMobile) : "",
                        Email: soldTo.ContactEmail || "",
                        Designation: soldTo.ContactDesignation || "",
                        AddressCode: soldTo.AddressCode || "",
                        Segment: soldTo.Segment || "",
                        Ship_BPCode: shipTo.BPCode || "",
                        Ship_BPName: shipTo.BPName || "",
                        Ship_BPGSTN: shipTo.BPGSTN || "",
                        Ship_CIN: shipTo.CIN || "",
                        Ship_BPTAN: shipTo.TAN || "",
                        Ship_Location: shipTo.Location || "",
                        Ship_Pincode: shipTo.Pincode != null ? String(shipTo.Pincode) : "",
                        Ship_BPAddress: shipTo.BPAddress || "",
                        Ship_ContactName: shipTo.ContactName || "",
                        Ship_Mobile: shipTo.ContactMobile != null ? String(shipTo.ContactMobile) : "",
                        Ship_Email: shipTo.ContactEmail || "",
                        Ship_Designation: shipTo.ContactDesignation || "",
                        Ship_AddressCode: shipTo.AddressCode || "",
                        scopeType: isob.Scope1 || "",
                        scopeText: isob.Scope_2 || "",
                        partOrder: isob.Scope_3 || "",
                        timelineOtherInformation: isob.Other_Info || "",
                    }));
                } else if (activeTab === 1) {
                    const [compRes, dwgRes] = await Promise.all([
                        getIsobPgCompData(isobObj).catch(() => ({ data: [] })),
                        getIsobDwgData(isobObj).catch(() => ({ data: [] })),
                    ]);
                    const comps = (compRes.data || []).map(c => ({ id: c.ID, productGroup: c.ProductGroup, pgComponent: c.PGComponent, color: c.Color, apoStd: c.APO_Color }));
                    const dwgs = (dwgRes.data || []).map(d => ({ id: d.ID, drawingNumber: d.DrawingNo, revisionNumber: d.DwgRevNo }));
                    changeTracker.setOriginalArray("comp", comps);
                    changeTracker.setOriginalArray("drw", dwgs);
                    setFormValues(prev => ({ ...prev, components: comps, drawings: dwgs }));
                } else if (activeTab === 2) {
                    const [pgCommRes, dealerSacRes, advanceRes, ldRes] = await Promise.all([
                        getIsobPgCommercialData(isobObj).catch(() => ({ data: [] })),
                        getIsobDealerSacData(isobObj).catch(() => ({ data: [] })),
                        getIsobAdvanceData(isobObj).catch(() => ({ data: [] })),
                        getIsobLdData(isobObj).catch(() => ({ data: [] })),
                    ]);
                    const pgDetails = (pgCommRes.data || []).map(p => ({
                        id: p.ID,
                        solutionOffering: p.ProductGroup,
                        bomPrice: String(p.BOM_Price || ""),
                        cobp: String(p.CustomerOrderPrice || ""),
                        dobp: String(p.DealerOrderBasicPrice || ""),
                        discountOnBomPrice: String(p.Percentage_Discount_on_BOMPrice || ""),
                        dealerMargin: String(p.Dealer_Margin || ""),
                    }));
                    changeTracker.setOriginalArray("pgCommercial", pgDetails);
                    const sac = dealerSacRes.data?.[0] || {};
                    const adv = advanceRes.data?.[0] || {};
                    const ld = ldRes.data?.[0] || {};
                    isobRecordIds.current.sacId = sac.ID;
                    isobRecordIds.current.advId = adv.ID;
                    isobRecordIds.current.ldId = ld.ID;
                    setFormValues(prev => ({
                        ...prev,
                        pgDetails,
                        Overall_Outflow: pgCommRes.data?.[0]?.Overall_Outflow || "",
                        FinalBasicPrice: pgCommRes.data?.[0]?.FinalBasicPrice || "",
                        supplyType: pgCommRes.data?.[0]?.supplyType || "",
                        serviceType: pgCommRes.data?.[0]?.serviceType || "",
                        DealerSAC_applicable: sac.DealerSAC_applicable || "No",
                        Dealer_SAC: sac.Dealer_SAC ? String(parseFloat(sac.Dealer_SAC) * 100) : "",
                        DealerSAC_value: sac.DealerSAC_value ? String(sac.DealerSAC_value) : "",
                        DealerCode: sac.DealerCode || "",
                        Order_closing: sac.Order_closing || false,
                        enquiryGeneration: sac.Enq_gen || false,
                        paymentCollection: sac.Payment_collection || false,
                        installation: sac.Installation || false,
                        creditSharing: sac.Credit_sharing || false,
                        Sharing_Branch: sac.Sharing_Branch || "",
                        Sharing_value: sac.Sharing_value ? String(sac.Sharing_value) : "",
                        SM: sac.SMId ? String(sac.SMId) : "",
                        Advance: adv.Advance ? String(parseFloat(adv.Advance) * 100) : "",
                        againstDeliveryPercent: adv.Adv_Delivery ? String(parseFloat(adv.Adv_Delivery) * 100) : "",
                        againstInstallationPercent: adv.Adv_Instalaltion ? String(parseFloat(adv.Adv_Instalaltion) * 100) : "",
                        installationCharge: adv.Installation_charge ? String(adv.Installation_charge) : "",
                        LD_applicable: ld.LD_applicable || "No",
                        LD_min: ld.LD_min ? String(parseFloat(ld.LD_min) * 100) : "",
                        ldMax: ld.LD_max ? String(parseFloat(ld.LD_max) * 100) : "",
                        deliveryStartDate: convertDateTimetoDateFormat(ld.Delivery_startdate) || "",
                        deliveryLDPerWeek: ld.Delivery_LD_per_week ? String(parseFloat(ld.Delivery_LD_per_week) * 100) : "",
                        deliveryEndDate: convertDateTimetoDateFormat(ld.Delivery_enddate) || "",
                        deliveryMaxLD: ld.Delivery_max_LD ? String(parseFloat(ld.Delivery_max_LD) * 100) : "",
                        instalStartDate: convertDateTimetoDateFormat(ld.Instal_startdate) || "",
                        instalLDPerWeek: ld.LD_x0025_perweek1 ? String(parseFloat(ld.LD_x0025_perweek1) * 100) : "",
                        instalEndDate: convertDateTimetoDateFormat(ld.Instal_enddate) || "",
                        instalMaxLD: ld.Instal_max_LD ? String(parseFloat(ld.Instal_max_LD) * 100) : "",
                    }));
                } else if (activeTab === 3) {
                    const miscRes = await getIsobMiscData(isobObj).catch(() => ({ data: [] }));
                    const misc = miscRes.data?.[0] || {};
                    isobRecordIds.current.miscId = misc.ID;
                    setMandatoryFields(prev => prev.filter(f => !["inspectionReqd", "projectSiteRegulatoryAct", "siteContactPerson", "siteContactMobile", "logisticsRemarks"].includes(f)));
                    setFormValues(prev => ({
                        ...prev,
                        inspectionReqd: misc.Inspection_reqd || "",
                        inspectionAt: misc.Inspection_at || "",
                        inspectionAgency: misc.Inspection_agency || "",
                        inspContactName: misc.Contact_name || "",
                        inspContactMobile: misc.Contact_mobile || "",
                        inspContactAddress: misc.Contact_address || "",
                        supplyRemarks: misc.Supply_Remarks || "",
                        siteContactPerson: misc.Site_Contact_Person || "",
                        siteContactMobile: misc.Site_Contact_Mobile != null ? String(misc.Site_Contact_Mobile) : "",
                        logisticsRemarks: misc.Logistics_Remarks || "",
                        miscInstallationBy: misc.Installation || "",
                        processCheckingVisitToFactory: misc.Process_check || "",
                        scopeOfPowerSupply: misc.Power_supply || "",
                        scopeOfExistingRacksRemoval: misc.Existing_racks_scope || "",
                        scopeOfUnloading: misc.Unloading || "",
                        multipleFloorDetails: misc.Multiple_floors_details || "",
                        projectSiteRegulatoryAct: misc.InstallationAct || "",
                        miscInstallationRemarks: misc.Installation_remarks || "",
                        miscQap: misc.QAP || false,
                        miscLoadTest: misc.Load_test || false,
                        miscSiteDimensionReconfirmed: misc.Site_dimension || false,
                        miscSiteReadinessForInstallation: misc.Site_readiness || false,
                        miscVisualInspectionOfFloor: misc.Visual_inspection || false,
                        miscExistingRacksToBeRemoved: misc.Exisitng_racks || false,
                        miscWorkingWarehouse: misc.Working_warehouse || false,
                        miscMultipleFloors: misc.Multiple_floors || false,
                        miscCoveredSpaceAvailable: misc.Covered_space || false,
                    }));
                }
            } catch (err) {
                console.error(`Error fetching ISOB data for tab ${activeTab}`, err);
            } finally {
                fetchedTabs.current.add(activeTab);
                setLoading(false);
            }
        };
        fetchTabData();
    }, [action, orderBookingFormData?.ID, activeTab,fetchTrigger]);

useEffect(() => {
    const fetchSalesRoleValue = async () => {
        try {
            const result = await getSalesUser();
            setSalesuser(result.data.map((item) => ({ field_1: item.field_1, SalespersonId: item.SalespersonId })));
            
        } catch (err) {
            console.error("Error fetching sales role data", err);
        }
    };
    fetchSalesRoleValue();
}, []);

  const getSalesRoleOptions = () => {
    return salesuser.map((item) => (
    <option key={item.field_1} value={String(item.SalespersonId)}>
      {item.field_1}
    </option>
  ));
};

console.log("salesrole in tab 3", salesRole);


    const getDropDownOptions = (title) => {
        return masterData.filter((Type) => Type.title === title).flatMap((Type) => Type.value.split(','))
            .map((value) => (
                <option key={value} value={value}>{value}</option>
            ));
    };
    console.log("masterdata in addisob", masterData)

    // const getIsobDropDownOptions = (fieldName) => {
    //     if (!isobDropdownData.length) return [];

    //     const uniqueValues = [...new Set(isobDropdownData.map(item => item[fieldName]).filter(Boolean))];
    //     return uniqueValues.map((value) => (
    //         <option key={value} value={value}>{value}</option>
    //     ));
    // };

    const getIsobDropDownOptions = (fieldName) => {
    if (!isobDropdownData.length) return [];
    const uniqueValues = [...new Set(isobDropdownData.map(item => item[fieldName]).filter(Boolean))];
    return uniqueValues.map((value) => (
        <option key={value} value={value}>{value}</option>
    ));
};

    console.log("formvalues in addisob", formValues);
    const tabFields = {
        0: [
            "BPCode", "BPName", "BPGSTN", "CIN", "BPTAN", "Location", "Pincode", "BPAddress",
            "ContactName", "Mobile", "Email", "Designation", "AddressCode",
            "Ship_BPCode", "Ship_BPName", "Ship_BPGSTN", "Ship_CIN", "Ship_BPTAN",
            "Ship_Location", "Ship_Pincode", "Ship_BPAddress",
            "Ship_ContactName", "Ship_Mobile", "Ship_Email", "Ship_Designation", "Ship_AddressCode",
            "PO_number", "POLOIDate", "DAPTechApprovalDate", "BOM_type", 
            "Segment", "WHType", "SKU_stored", "DocumentExchangePlace",
            "SMSalaryCode", "SMMobileNo", "RelatedToPastSupply", "PastSONo"
        ],
        1: ["components", "drawings", "scopeType", "scopeText", "partOrder"],
        2: [
            "pgDetails", "supplyType", "serviceType", "DealerSAC_applicable", "Dealer_SAC",
            "DealerSAC_value", "DealerCode", "Order_closing", "enquiryGeneration", "paymentCollection",
            "installation", "creditSharing", "Advance", "againstDeliveryPercent",
            "againstInstallationPercent", "installationCharge", "LD_applicable", "LD_min", "ldMax",
            "deliveryStartDate", "deliveryLDPerWeek", "deliveryEndDate", "deliveryMaxLD",
            "instalStartDate", "instalLDPerWeek", "instalEndDate", "instalMaxLD", "Overall_Outflow", "FinalBasicPrice", "Sharing_Branch", "Sharing_value", "SM",
            "approvedDiscount", "OrderValueLakhs"
        ],
        3: ["inspectionReqd", "inspectionAt", "inspectionAgency", "inspContactName", "inspContactMobile", "inspContactAddress", "supplyRemarks",
            "siteContactPerson", "siteContactMobile", "logisticsRemarks",
            "projectSiteRegulatoryAct", "miscQap", "miscLoadTest", "miscSiteDimensionReconfirmed",
            "miscSiteReadinessForInstallation", "miscVisualInspectionOfFloor", "miscExistingRacksToBeRemoved",
            "miscWorkingWarehouse", "miscMultipleFloors", "miscCoveredSpaceAvailable",
            "processCheckingVisitToFactory", "miscInstallationBy", "scopeOfPowerSupply",
            "scopeOfExistingRacksRemoval", "scopeOfUnloading", "multipleFloorDetails", "miscInstallationRemarks"],
        4: ["DesignStartDate", "DesignFinishDate", "SupplyStartDate", "SupplyFinishDate",
            "InstallationStartDate", "InstallationFinishDate", "ZeroDate", "OtherInformation","timelineOtherInformation"]
    };

    console.log(`tabwise formvalues in addisob (Tab ${activeTab + 1})`, Object.fromEntries(
        (tabFields[activeTab] || []).filter(key => formValues[key] !== undefined && formValues[key] !== "").map(key => [key, formValues[key]])
    ));

    const arrayFields = ["components", "drawings", "pgDetails"];

    // const handleReset = () => {
    //     const fields = tabFields[activeTab] || [];
    //     setFormValues((prev) => {
    //         const updated = { ...prev };
    //         fields.forEach((key) => {
    //             if (key === "POLOIDate" || key === "DAPTechApprovalDate") {
    //                 updated[key] = today;
    //             } else if (arrayFields.includes(key)) {
    //                 updated[key] = [];
    //             } else {
    //                 updated[key] = "";
    //             }
    //         });
    //         return updated;
    //     });
    //     setError({});
    //     setMandatoryFields([]);
    //     setResetKey((prev) => prev + 1);
    // };

    const handleReset = () => {
        if (action === "Edit") {
            fetchedTabs.current.delete(activeTab);
            setFetchTrigger((prev) => prev + 1);
            setResetKey((prev) => prev + 1);
            setError({});
            setMandatoryFields([]);
            setTabDirty(false);
            return;
        }
        const fields = tabFields[activeTab] || [];
        const preserveKeys = ["BPCode", "BPName"];
        setFormValues((prev) => {
            const updated = { ...prev };
            if (activeTab === 0) updated.copySoldTo = false;
            fields.forEach((key) => {
                if (preserveKeys.includes(key)) return;
                if (key === "POLOIDate" || key === "DAPTechApprovalDate") {
                    updated[key] = today;
                } else if (arrayFields.includes(key)) {
                    updated[key] = [];
                } else {
                    updated[key] = "";
                }
            });
            return updated;
        });
        setError({});
        setMandatoryFields([]);
        setTabDirty(false);
        setResetKey((prev) => prev + 1);
    };

    const handleInputChange = (e) => {
        if (action === "View") return;
        const { name, value } = e.target;
        if (name === "__bulk__") {
            const hasChange = Object.keys(value).some(k => formValues[k] !== value[k]);
            if (!hasChange) return;
            changeTracker.markDirty(name, value);
            setTabDirty(true);
            setFormValues((prev) => ({ ...prev, ...value }));
        } else {
            if (formValues[name] === value) return;
            changeTracker.markDirty(name);
            setTabDirty(true);
            setFormValues((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleBack = () => {
        onBack();
    };

    const handleTabChange = (tabIndex) => {
        if (tabIndex === activeTab) return;
        if (tabDirty && action !== "View" && tabIndex > activeTab) {
            setPendingTab(tabIndex);
            Alert('error', `You have unsaved changes on ${tabLabels[activeTab]}. Please save before navigating.`);
            return;
        }
        proceedToTab(tabIndex);
    };

    const proceedToTab = (tabIndex) => {
        setMandatoryFields([]);
        setError({});
        setTabDirty(false);
        setPendingTab(null);
        setActiveTab(tabIndex);
        setResetKey((prev) => prev + 1);
        document.querySelector(".scrollForm.isob")?.scrollTo({ top: 0 });
    };

    const handlePrev = () => {
        if (activeTab > 0) handleTabChange(activeTab - 1);
    };
    const buildIsobMain = (fv) => ({
        POnumber: fv.PO_number || "",
        PODate: fv.POLOIDate || "",
        TechApprovalDate: fv.DAPTechApprovalDate || "",
        BOM_type: fv.BOM_type || "",
        Application: fv.WHType || "",
        SKU_stored: fv.SKU_stored || "",
        DocumentExchangePlace: fv.DocumentExchangePlace || "",
        Past_supply: fv.RelatedToPastSupply || "",
        SO_number: fv.PastSONo || "",
        Scope1: fv.scopeType || "",
        Scope_2: fv.scopeText || "",
        Scope_3: fv.partOrder || "",
    });

    const buildBpRecord = (fv, prefix, bpType) => ({
        BPCode: fv[`${prefix}BPCode`] || "",
        BPName: fv[`${prefix}BPName`] || "",
        BPGSTN: fv[`${prefix}BPGSTN`] || "",
        CIN: fv[`${prefix}CIN`] || "",
        TAN: fv[`${prefix}BPTAN`] || "",
        Location: fv[`${prefix}Location`] || "",
        Pincode: fv[`${prefix}Pincode`] || "",
        BPAddress: fv[`${prefix}BPAddress`] || "",
        ContactName: fv[`${prefix}ContactName`] || "",
        ContactMobile: fv[`${prefix}Mobile`] || "",
        ContactEmail: fv[`${prefix}Email`] || "",
        ContactDesignation: fv[`${prefix}Designation`] || "",
        AddressCode: fv[`${prefix}AddressCode`] || "",
        Segment: fv.Segment || "",
        BPType: bpType,
    });

    const buildLdDetails = (fv) => ({
        LD_applicable: fv.LD_applicable || "",
        LD_min: (parseFloat(fv.LD_min) / 100) || 0,
        LD_max: (parseFloat(fv.ldMax) / 100) || 0,
        Delivery_startdate: fv.deliveryStartDate || "",
        Delivery_LD_per_week: (parseFloat(fv.deliveryLDPerWeek) / 100) || 0,
        Delivery_enddate: fv.deliveryEndDate || "",
        Delivery_max_LD: (parseFloat(fv.deliveryMaxLD) / 100) || 0,
        Instal_startdate: fv.instalStartDate || "",
        LD_x0025_perweek1: (parseFloat(fv.instalLDPerWeek) / 100) || 0,
        Instal_enddate: fv.instalEndDate || "",
        Instal_max_LD: (parseFloat(fv.instalMaxLD) / 100) || 0,
    });

    const buildDealerSac = (fv) => ({
        DealerSAC_applicable: fv.DealerSAC_applicable || "",
        Dealer_SAC: (parseFloat(fv.Dealer_SAC) / 100) || 0,
        DealerSAC_value: parseFloat(fv.DealerSAC_value) || 0,
        DealerCode: fv.DealerCode || "",
        Order_closing: !!fv.Order_closing,
        Enq_gen: !!fv.enquiryGeneration,
        Payment_collection: !!fv.paymentCollection,
        Installation: !!fv.installation,
        Credit_sharing: !!fv.creditSharing,
        Sharing_Branch: fv.Sharing_Branch || "",
        Sharing_value: parseFloat(fv.Sharing_value) || 0,
        SMId: parseFloat(fv.SM) || 0,
    });

    const buildAdvance = (fv) => ({
        Advance: (parseFloat(fv.Advance) / 100) || 0,
        Adv_Delivery: (parseFloat(fv.againstDeliveryPercent) / 100) || 0,
        Adv_Instalaltion: (parseFloat(fv.againstInstallationPercent) / 100) || 0,
        Installation_charge: parseFloat(fv.installationCharge) || 0,
    });

    const buildMisc = (fv) => ({
        Inspection_reqd: fv.inspectionReqd || "",
        Inspection_at: fv.inspectionAt || "",
        Inspection_agency: fv.inspectionAgency || "",
        Contact_name: fv.inspContactName || "",
        Contact_mobile: fv.inspContactMobile || "",
        Contact_address: fv.inspContactAddress || "",
        Supply_Remarks: fv.supplyRemarks || "",
        Site_Contact_Person: fv.siteContactPerson || "",
        Site_Contact_Mobile: fv.siteContactMobile || "",
        Logistics_Remarks: fv.logisticsRemarks || "",
        Installation: fv.miscInstallationBy || "",
        Process_check: fv.processCheckingVisitToFactory || "",
        Power_supply: fv.scopeOfPowerSupply || "",
        Existing_racks_scope: fv.scopeOfExistingRacksRemoval || "",
        Unloading: fv.scopeOfUnloading || "",
        Multiple_floors_details: fv.multipleFloorDetails || "",
        InstallationAct: fv.projectSiteRegulatoryAct || "",
        Installation_remarks: fv.miscInstallationRemarks || "",
        QAP: fv.miscQap || false,
        Load_test: fv.miscLoadTest || false,
        Site_dimension: fv.miscSiteDimensionReconfirmed || false,
        Site_readiness: fv.miscSiteReadinessForInstallation || false,
        Visual_inspection: fv.miscVisualInspectionOfFloor || false,
        Exisitng_racks: fv.miscExistingRacksToBeRemoved || false,
        Working_warehouse: fv.miscWorkingWarehouse || false,
        Multiple_floors: fv.miscMultipleFloors || false,
        Covered_space: fv.miscCoveredSpaceAvailable || false,
    });

    const structureIsobData = () => {
        const fv = formValues;
        const mainPayload = {
            _recordIds: { ...isobRecordIds.current },
            _snapshots: {
                isob:          buildIsobMain(fv),
                isobBpSoldTo:  buildBpRecord(fv, "", "Sold To"),
                isobBpShipTo:  buildBpRecord(fv, "Ship_", "Ship To"),
                isobLd:        buildLdDetails(fv),
                isobDealerSac: buildDealerSac(fv),
                isobAdvance:   buildAdvance(fv),
                isobMisc:      buildMisc(fv),
            },
            tab1: {
                isob: { ...buildIsobMain(fv), Other_Info: fv.timelineOtherInformation || "" },
                isobBp: [
                    buildBpRecord(fv, "", "Sold To"),
                    buildBpRecord(fv, "Ship_", "Ship To"),
                ],
            },
            tab2: {
                comp: fv.components || [],
                drw: fv.drawings || [],
                scope: {
                    scopeType: fv.scopeType || "",
                    scopeText: fv.scopeText || "",
                    partOrder: fv.partOrder || "",
                },
            },
            tab3: {
                pgCommercial: {
                    pgDetails:       fv.pgDetails || [],
                    Overall_Outflow: fv.Overall_Outflow || "",
                    FinalBasicPrice: fv.FinalBasicPrice || "",
                    supplyType:      fv.supplyType || "",
                    serviceType:     fv.serviceType || "",
                },
                ldDetails:  buildLdDetails(fv),
                dealerSac:  buildDealerSac(fv),
                advance:    buildAdvance(fv),
            },
            tab4: { misc: buildMisc(fv) },
            tab5: {
                timelines: {
                    DesignStartDate:        fv.DesignStartDate || "",
                    DesignFinishDate:       fv.DesignFinishDate || "",
                    SupplyStartDate:        fv.SupplyStartDate || "",
                    SupplyFinishDate:       fv.SupplyFinishDate || "",
                    InstallationStartDate:  fv.InstallationStartDate || "",
                    InstallationFinishDate: fv.InstallationFinishDate || "",
                    ZeroDate:               fv.ZeroDate || "",
                    OtherInformation:       fv.OtherInformation || "",
                },
            },
        };

        return mainPayload;
    };

    const handleSaveAndContinue = () => {
        if (activeTab < 4) {
            const nextTab = activeTab + 1;
            setMaxVisitedTab(prev => Math.max(prev, nextTab));
            setTabDirty(false);
            proceedToTab(nextTab);
        }
        Alert('success', `${tabLabels[activeTab]} saved successfully.`);
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log("ISOB Submit", formValues);
    //     onBack();
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Compute array-level diffs before structuring
        changeTracker.computeArrayChanges("comp", formValues.components || []);
        changeTracker.computeArrayChanges("drw", formValues.drawings || []);
        changeTracker.computeArrayChanges("pgCommercial", formValues.pgDetails || []);

        const structuredData = structureIsobData();
        // Attach change metadata
        structuredData._dirtyLists = Array.from(changeTracker.getDirtyLists());
        structuredData._arrayChanges = {
            comp: changeTracker.getArrayChanges("comp"),
            drw: changeTracker.getArrayChanges("drw"),
            pgCommercial: changeTracker.getArrayChanges("pgCommercial"),
        };
        console.log("ISOB Structured Data", structuredData);
        console.log("Dirty Lists", structuredData._dirtyLists);
        console.log("Array Changes", structuredData._arrayChanges);
        Alert('success', `${tabLabels[activeTab]} saved successfully.`);
        structuredData._isEdit = action === "Edit";
        setLoading(true)
        setTimeout(() => {
            Alert('success', 'ISOB details saved successfully.');
            setLoading(false)
            onBack(structuredData, formValues);
        }, 1000);
    };

    const renderTabContent = () => {
        const commonProps = { formValues, handleInputChange, error, setError, mandatoryFields, setMandatoryFields, getDropDownOptions, getIsobDropDownOptions, orderBookingFormData, getSalesRoleOptions, enquiryData, discountRecord, readOnly: action === "View" };
        switch (activeTab) {
            case 0: return <IsobTab1 key={resetKey} {...commonProps} />;
            case 1: return <IsobTab2 key={resetKey} {...commonProps} />;
            case 2: return <IsobTab3 key={resetKey} {...commonProps} />;
            case 3: return <IsobTab4 key={resetKey} {...commonProps} />;
            case 4: return <IsobTab5 key={resetKey} {...commonProps} />;
            default: return null;
        }
    };

    return (
        <>
            {loading && (
                <div className="loader-box">
                    {" "}
                    <img src={Loader} alt="Loading" className="newloader"></img>{" "}
                </div>
            )}

            <div className="add-isob-booking-container">
                <div className="add-isob-header">
                    <h4 className="add-isob-title">Internal Sales Order Booking (ISOB)</h4>
                    <div className="back-btn" onClick={handleBack}>
                        <span className="back-btn-arrow">&lt;</span>
                        &nbsp;
                        <span className="back-btn-label">Back to order booking details</span>
                    </div>
                </div>

                <div className="isob-stepper">
                    <div className="isob-stepper-track">
                        {tabLabels.map((label, index) => {
                            const isDisabled = index > activeTab && (
                                mandatoryFields.length > 0 ||
                                (index > maxVisitedTab && index > activeTab + 1)
                            ) && action != "View";
                            // const isDisabled = false
                            return (
                                <React.Fragment key={index}>
                                    <div
                                        className={`isob-step-circle ${index < activeTab ? "completed" : ""} ${index === activeTab ? "active" : ""} ${isDisabled ? "disabled" : ""}`}
                                        onClick={() => {
                                            !isDisabled && handleTabChange(index);
                                            isDisabled && (Alert('error', `Please save ${tabLabels[activeTab]} tab before navigating.`));
                                        }}
                                    />
                                    {index < tabLabels.length - 1 && (
                                        <div className={`isob-step-line ${index < activeTab ? "completed" : ""}`} />
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                    <div className="isob-stepper-labels">
                        {tabLabels.map((label, index) => {
                            const isDisabled = index > activeTab && (
                                mandatoryFields.length > 0 ||
                                (index > maxVisitedTab && index > activeTab + 1)
                            ) && action != "View";
                            // const isDisabled = false
                            return (
                                <div
                                    className={`isob-step-label-group ${isDisabled ? "disabled" : ""}`}
                                    key={index}
                                    onClick={() => {
                                        !isDisabled && handleTabChange(index);
                                        isDisabled && (Alert('error', `Please save ${tabLabels[activeTab]} tab before navigating.`));
                                    }}
                                >
                                    <span className={`isob-step-label ${index === activeTab ? "active" : ""}`}>Step {index + 1}</span>
                                    <span className="isob-step-title">{label}</span>
                                </div>
                            );
                        })}
                    </div>
                    {isMobile && (
                        <div className="isob-stepper-active-title">
                            {activeTab + 1}. {tabLabels[activeTab]}
                        </div>
                    )}
                </div>

                <div className="scrollForm isob add-order-booking-content">
                    <Form>
                        <div className="isob-tab-div">
                            {renderTabContent()}
                        </div>

                        <div className="add-order-booking-footer isob-footer">
                            <div className="isob-footer-left">
                                <Button bsPrefix="reset-btn" className="reset-btn-primary" onClick={handleBack}>
                                    Back to Order Booking
                                </Button>
                                {activeTab > 0 && !isMobile && (
                                    <Button bsPrefix="reset-btn" className="reset-btn-primary" onClick={handlePrev}>
                                        Prev
                                    </Button>
                                )}
                            </div>
                            {isMobile && action !== "View" && (
                                <div className="isob-footer-middle">
                                    <Button bsPrefix="reset-btn" className="reset-btn-primary" onClick={handleReset}>
                                        Reset
                                    </Button>
                                    {activeTab > 0 && (
                                        <Button bsPrefix="reset-btn" className="reset-btn-primary" onClick={handlePrev}>
                                            Prev
                                        </Button>
                                    )}
                                </div>
                            )}
                            {isMobile && action === "View" && activeTab > 0 && (
                                <div className="isob-footer-middle">
                                    <Button bsPrefix="reset-btn" className="reset-btn-primary" onClick={handlePrev}>
                                        Prev
                                    </Button>
                                </div>
                            )}
                            <div className="isob-footer-right">
                                {!isMobile && action !== "View" && (
                                    <Button bsPrefix="reset-btn" className="reset-btn-primary" onClick={handleReset}>
                                        Reset
                                    </Button>
                                )}
                                {activeTab < 4 && action !== "View" && (
                                    <Button variant="primary" className="btn-primary" onClick={handleSaveAndContinue} disabled={mandatoryFields.length > 0 || Object.values(error).some(v => v && v !== "")}>
                                        Save &amp; Continue
                                    </Button>
                                )}
                                {activeTab === 4 && action !== "View" && (
                                    <Button variant="primary" className="btn-primary" onClick={handleSubmit} disabled={mandatoryFields.length > 0 || Object.values(error).some(v => v && v !== "")}>
                                        Submit
                                    </Button>
                                )}
                                {activeTab < 4 && action === "View" && (
                                    <Button variant="primary" className="btn-primary" onClick={() => handleTabChange(activeTab + 1)}>
                                        Next
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
}
